var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RoamTransactionListTemplate',{attrs:{"screenConfig":_vm.setScreenConfig,"isXSmall":_vm.isXSmall,"isLarge":_vm.isLarge,"barcodeScanned":_vm.barcodeScanned,"formsConfig":_vm.formsConfig,"setLoading":_vm.setLoading,"rowClick":_vm.rowClickCallBack,"persistenceKey":'roam-despatch-order-list'}})
}
var staticRenderFns = []

export { render, staticRenderFns }